import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard2 from "./Pages/Dashboard2/Dashboard2";
import Login from "./Pages/Login/Login";
import TransactionLedger from "./Pages/TransactionsLedger/TransactionLedger";
import Profile from "./Pages/Profile/Profile";
import Savings from "./Pages/Savings/Savings";
import MemberRegistration from "./Pages/Member Registration/MemberRegistration";
import LoanLedger from "./Pages/LoanLedger/LoanLedger";
import SavingsLedger from "./Pages/SavingsLedger/SavingsLedger";
import LoanApplication from "./Pages/Loan Application/LoanApplication";
import Dividends from "./Pages/Dividends/Dividends";
import Dividend from "./Pages/Dividends/Dividends";
import Dividendss from "./Pages/Dividends/Dividend";
import SavingsPage from "./Pages/Savings/SavingsForm";
import LoanOverview from "./Pages/LoanOverview/LoanOverview";
import SavingsForm from "./Pages/Savings/SavingsForm";
import Login2 from "./Pages/Login/Login2";
import SavingsWithdrawlForm from "./Pages/Savings/WithdrawlForm";
import ApplyForLoan from "./Pages/Apply for Loan/ApplyForLoan";
import Support from "./Pages/Support/Support";
import GuarantorApproval from "./Pages/Guarantor Approval/GuarantorApproval";
import ScrollToTop from "./Components/ScrollToTop";
import SavingsPersonalLedger from "./Pages/Personal Ledger/SavingsPersonalLedger";
import LoanPersonalLedger from "./Pages/Personal Ledger/LoanPersonalLedger";
import Deductions from "./Pages/Deductions/Deductions";
import Applications from "./Pages/All Applications/Applications";
import SavingsApplications from "./Pages/All Applications/SavingsApplications";
import ForgotPassword from "./Pages/Login/ForgotPassword";
import PasswordReset from "./Pages/Login/PasswordReset";



function App() {
  return (
    <Router>
       <ScrollToTop />
      <Routes>
        <Route path="/" element={<Login2 />} />
        <Route path="/dashboard" element={<Dashboard2 />} />
        <Route path="/login" element={<Login2 />} />
        <Route path="/forgot_password" element={<ForgotPassword />} />
        <Route path="/password_reset" element={<PasswordReset />} />
        <Route path="/transaction_ledger" element={<TransactionLedger />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/member-registration" element={<MemberRegistration />} />
        <Route path="/loans/ledger" element={<LoanLedger />} />
        <Route path="/loans/member-ledger" element={<LoanPersonalLedger />} />
        <Route path="/loans/my-loan-applications" element={<Applications />} />
        <Route path="/savings/my-savings" element={<SavingsApplications />} />
        <Route path="/deductions" element={<Deductions />} />
        {/* <Route path="/loans/apply" element={<ApplyForLoan />} /> */}
        <Route path="/dividends" element={<Dividendss />} />
        <Route path="/loans/overview" element={<LoanOverview />} />
        <Route path="/loans" element={<LoanOverview />} />
        <Route path="/savings/overview" element={<Savings />} />
        <Route path="/savings" element={<Savings />} />
        
        {/* <Route path="/apply-savings" element={<SavingsPage />} /> */}
        <Route path="/savings/member-savings" element={<SavingsForm />} />
        <Route path="/savings/withdrawal-request" element={<SavingsWithdrawlForm />} />
        <Route path="/savings/ledger" element={<SavingsLedger />} />

        <Route path="/savings/member-ledger" element={<SavingsPersonalLedger />} />
        <Route path="/loans/loan-application" element={<LoanApplication />} />
        <Route path="/support" element={<Support />} />
        <Route path="/loans/guarantor-approval" element={<GuarantorApproval />} />
      </Routes>
    </Router>
  );
}

export default App;